<template>
  <div class="table-frame">
    <div class="table students-table">
      <div class="table__header">
        <div class="table__header-col">
          <label for="all" class="checkbox--white">
            <input
              id="all"
              v-model="selected_all"
              type="checkbox"
              class="checkbox__input"
              @change="selectAll()"
            />
            <div class="checkbox__marker"></div>
          </label>
        </div>
        <div class="table__header-col">
          <span> תמונה </span>
        </div>
        <div class="table__header-col">
          <span>
            שם מלא
            <TableSortBtn
              @asc="sort('full_name', 'asc')"
              @desc="sort('full_name', 'desc')"
            />
          </span>
        </div>
        <div class="table__header-col">
          <span>
            מסגרת
            <TableSortBtn
              @asc="sort('campus_name', 'asc')"
              @desc="sort('campus_name', 'desc')"
            />
          </span>
        </div>
        <div class="table__header-col">
          <span>
            קבוצה
            <TableSortBtn
              @asc="sort('group_name', 'asc')"
              @desc="sort('group_name', 'desc')"
            />
          </span>
        </div>
        <div class="table__header-col">
          <span>
            כיתה
            <TableSortBtn
              @asc="sort('class_name', 'asc')"
              @desc="sort('class_name', 'desc')"
            />
          </span>
        </div>
        <div class="table__header-col">
          <span>
            טלפון נייד
            <TableSortBtn
              @asc="sort('mobile', 'asc')"
              @desc="sort('mobile', 'desc')"
            />
          </span>
        </div>
        <div class="table__header-col">
          <span> דורש טיפול </span>
        </div>
        <div class="table__header-col">
          <span> מיקום </span>
        </div>
      </div>
      <div v-if="loading" class="table__body">
        <simple-preloader />
      </div>
      <template v-else>
        <div
          v-if="students_data && students_data.length > 0"
          class="table__body"
        >
          <div
            v-for="(student, index) in students_data"
            :key="'student_' + student.id"
            class="table__row"
            :class="{
              'table__row--blocked':
                student.user.last_block &&
                student.user.last_block.is_blocked === 1
            }"
          >
            <div class="table__col" @click.stop>
              <label :for="'checkbox-' + index" class="checkbox">
                <input
                  :id="'checkbox-' + index"
                  v-model="student.selected"
                  :name="'checkbox'"
                  type="checkbox"
                  class="checkbox__input"
                  @change="onStudentToggle(student)"
                />
                <div class="checkbox__marker" />
              </label>
            </div>
            <div class="table__col">
              <div class="students-table__ava">
                <img
                  v-avatar-placeholder
                  :src="'/storage/' + student.user.img"
                  alt=""
                />
              </div>
            </div>
            <div class="table__col">
              {{ student.user.full_name }}
            </div>
            <div class="table__col">
              <span>מסגרת:</span> {{ student.user.campus.name }}
            </div>
            <div class="table__col">
              <span>קבוצה:</span> {{ student.group ? student.group.name : '-' }}
            </div>
            <div class="table__col">
              <span>כיתה:</span
              ><b dir="ltr">{{ student.user.class_name || '-' }}</b>
            </div>
            <div class="table__col">
              {{ student.user.mobile }}
            </div>
            <div class="table__col">
              <div
                class="content_danger"
                v-if="
                  (student.need_to_watch.danger &&
                    student.need_to_watch.danger > 0) ||
                  (student.need_to_watch.warning &&
                    student.need_to_watch.warning > 0)
                "
              >
                <template
                  v-if="
                    student.need_to_watch.warning &&
                    student.need_to_watch.warning > 0
                  "
                >
                  <img src="/images/alert-triangle-2.svg" alt="" />
                  <span>{{ student.need_to_watch.warning }}</span>
                </template>
                <div
                  v-if="
                    student.need_to_watch.danger &&
                    student.need_to_watch.danger > 0
                  "
                >
                  <img src="/images/alert-triangle.svg" alt="" />
                  <span>{{ student.need_to_watch.danger }}</span>
                </div>
              </div>
              <span v-else>-</span>
            </div>
            <div class="table__col" />
            <div
              v-for="status in student.exit_permission_user_statuses"
              :key="status + student.id"
            >
              <div
                v-if="status.status == 'expired_delay'"
                :class="{
                  'didn-come-back-content': status.status === 'expired_delay'
                }"
              >
                <img class="image-status" src="/images/didnt-come-back.svg" />
              </div>
              <div
                v-if="status.status === 'active_use'"
                :class="{
                  'exit-content': status.status === 'active_use'
                }"
              >
                <img src="/images/exit.svg" class="image-status" />
              </div>
            </div>
            <router-link
              :to="{ name: 'StudentEdit', params: { id: student.id } }"
              class="table__link"
            />
          </div>
          <infinite-loading :identifier="infiniteId" @infinite="loadMore">
            <template #spinner>
              <simple-preloader />
            </template>
            <template #no-results><span /></template>
          </infinite-loading>

          <!--
                                                                    <div class="table__row students-table__alert-row">
                                                                        <div class="table__col">
                                                                            <label for="checkbox-1" class="checkbox">
                                                                                <input id="checkbox-1" type="checkbox" class="checkbox__input">
                                                                                <div class="checkbox__marker"></div>
                                                                            </label>
                                                                        </div>
                                                                        <div class="table__col">
                                                                            <div class="students-table__ava">
                                                                                <img src="img/ava-student.png" alt="">
                                                                            </div>
                                                                        </div>
                                                                        <div class="table__col">אלון דיין</div>
                                                                        <div class="table__col"><span>מסגרת:</span> פנימיה</div>
                                                                        <div class="table__col"><span>קבוצה:</span>	גליל</div>
                                                                        <div class="table__col"><span>כיתה:</span> יא׳ 1</div>
                                                                        <div class="table__col">0541234567</div>
                                                                        <div class="table__col">
                                                                            <img src="img/alert-triangle.svg" alt="">
                                                                            10
                                                                        </div>
                                                                        <div class="table__col">
                                                                            <div class="status status&#45;&#45;red">
                                                                                בחוץ
                                                                            </div>
                                                                        </div>
                                                                        <a href="dashboard.html" class="table__link"></a>
                                                                    </div>
                                                                    <div class="table__row">
                                                                        <div class="table__col">
                                                                            <label for="checkbox-2" class="checkbox">
                                                                                <input id="checkbox-2" type="checkbox" class="checkbox__input">
                                                                                <div class="checkbox__marker"></div>
                                                                            </label>
                                                                        </div>
                                                                        <div class="table__col">
                                                                            <div class="students-table__ava">
                                                                                <img src="img/ava-student.png" alt="">
                                                                            </div>
                                                                        </div>
                                                                        <div class="table__col">אלון דיין</div>
                                                                        <div class="table__col"><span>מסגרת:</span> פנימיה</div>
                                                                        <div class="table__col"><span>קבוצה:</span>	גליל</div>
                                                                        <div class="table__col"><span>כיתה:</span> יא׳ 1</div>
                                                                        <div class="table__col">0541234567</div>
                                                                        <div class="table__col">
                                                                            <img src="img/alert-triangle-2.svg" alt="">
                                                                            10
                                                                        </div>
                                                                        <div class="table__col">

                                                                        </div>
                                                                        <a href="dashboard.html" class="table__link"></a>
                                                                    </div>
                    -->
        </div>
        <TheEmptyTable v-else />
      </template>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import TheEmptyTable from '@/Components/Layout/TheEmptyTable';
import SimplePreloader from '@/Components/SimplePreloader';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  components: {
    TheEmptyTable,
    SimplePreloader,
    InfiniteLoading
  },
  props: {
    students: Array,
    loading: Boolean,
    infiniteId: {
      type: [Number, String],
      default: 0
    },
    selectAllMode: Boolean,
    checkedFixed: {
      type: Boolean,
      default: undefined
    }
  },
  data() {
    return {
      students_data: [],
      selected_all: false,
      all_selected: false,
      perPage: 50,
      page: 1
    };
  },
  computed: {
    ...mapGetters({
      studentsUpdated: 'students/studentsUpdated',
      levelUpEvent: 'students/levelUpEvent',
      deleteEvent: 'students/deleteEvent'
    }),
    selectedStudents() {
      return this.students_data.filter(s => s.selected);
    }
    // displayStudents() {
    //   return this.students_data.slice(0, this.page * this.perPage);
    // }
  },
  watch: {
    studentsUpdated(val) {
      if (val && val.status) {
        this.studentsUpdate([]);
        this.updateSelectedStudents(val);
      }
    },
    levelUpEvent(val) {
      if (val) {
        this.levelUpTrigger(false);
        this.classLevelUp();
      }
    },
    deleteEvent(val) {
      if (val) {
        this.deleteTrigger(false);
        this.deleteStudents();
      }
    },
    checkedFixed(val) {
      if (val !== false) {
        return;
      }
      this.all_selected = false;
      this.selected_all = false;
      (this.students_data || []).forEach(s => {
        this.$set(s, 'selected', false);
      });
    },
    selectAllMode(val) {
      this.all_selected = !!val;
      if (val) {
        this.selected_all = true;
      }
    },
    students(val) {
      const list = val || [];
      const markNew = this.all_selected || this.selectAllMode;
      list.forEach(s => {
        if (typeof s.selected === 'undefined') {
          this.$set(s, 'selected', markNew);
        }
      });
      this.students_data = list;
    }
  },
  created() {
    this.students_data = this.students;
  },
  methods: {
    sort(key, type) {
      const newArray = this.students_data.sort((a, b) => {
        if (type === 'asc') {
          if (key === 'full_name') {
            return a.user.full_name > b.user.full_name ? -1 : 1;
          } else if (key === 'campus_name') {
            return a.user.campus.name > b.user.campus.name ? -1 : 1;
          } else if (key === 'group_name') {
            if (a.user.group) {
              return a.user.group.name > b.user.group.name ? -1 : 1;
            } else {
              return -1;
            }
          } else if (key === 'class_name') {
            if (a.student_class) {
              return a.student_class.class_name > b.student_class.class_name
                ? -1
                : 1;
            } else {
              return -1;
            }
          } else {
            return a.user.mobile > b.user.mobile ? -1 : 1;
          }
        } else if (key === 'full_name') {
          return a.user.full_name < b.user.full_name ? -1 : 1;
        } else if (key === 'campus_name') {
          return a.user.campus.name < b.user.campus.name ? -1 : 1;
        } else if (key === 'group_name') {
          if (a.user.group) {
            return a.user.group.name < b.user.group.name ? -1 : 1;
          } else {
            return -1;
          }
        } else if (key === 'class_name') {
          if (a.student_class) {
            return a.student_class.class_name < b.student_class.class_name
              ? -1
              : 1;
          } else {
            return -1;
          }
        } else {
          return a.user.mobile < b.user.mobile ? -1 : 1;
        }
      });
      this.students_data = [...newArray];
    },
    ...mapActions({
      studentsUpdate: 'students/studentsUpdate',
      levelUpTrigger: 'students/levelUpTrigger',
      deleteTrigger: 'students/deleteTrigger',
      listReloadTrigger: 'students/listReloadTrigger'
    }),
    loadMore($state) {
      this.$emit('loadMore', $state);
      // setTimeout(() => {
      //   this.page += 1;
      //   this.$nextTick(() => {
      //     if (this.students_data.length === this.displayStudents.length) {
      //       $state.complete();
      //     } else {
      //       $state.loaded();
      //     }
      //   });
      // }, 350);
    },
    onStudentToggle(student) {
      this.$set(student, 'selected', !!student.selected);
      if (!this.all_selected && !this.selectAllMode) {
        return;
      }
      const excludeIds = (this.students_data || [])
        .filter(s => !s.selected)
        .map(s => s.id);
      this.$emit('all_selected', excludeIds);
    },
    selectAll() {
      this.all_selected = this.selected_all;
      (this.students_data || []).forEach(s => {
        this.$set(s, 'selected', this.selected_all);
      });
      if (this.all_selected) {
        this.$emit('all_selected', []);
      } else {
        this.$emit('removeAllSelected');
      }
    },
    getSelectedStudentsId() {
      return this.selectedStudents.map(s => s.id);
    },
    updateSelectedStudents(data) {
      const selected = this.getSelectedStudentsId();
      data.students = selected;
      axios
        .post('/api/students/update', data)
        .then(res => {
          this.listReloadTrigger(true);
          this.$toastr.s('נשמר');
        })
        .catch(err => {
          this.$toastr.e('שגיאה');
        });
    },
    classLevelUp() {
      const selected = this.getSelectedStudentsId();
      console.log(selected, 'levelUp');
      axios
        .post('/api/students/class-level-up', { students: selected })
        .then(res => {
          this.listReloadTrigger(true);
          this.$toastr.s('נשמר');
        })
        .catch(err => {
          this.$toastr.e('שגיאה');
        });
    },
    deleteStudents() {
      const selected = this.getSelectedStudentsId();
      axios
        .post('/api/students/delete', { students: selected })
        .then(res => {
          this.listReloadTrigger(true);
          this.$toastr.s('הוסר');
        })
        .catch(err => {
          this.$toastr.e('שגיאה');
        });
    }
  }
};
</script>
<style scoped>
.active-use_content {
  background: skyblue;
}
.expired-use_content {
  background: tomato;
}

.image-status {
  position: absolute;
  left: 50px;
  top: 15px;
}
.table__row--blocked::after {
  position: absolute;
  content: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
@media (max-width: 767px) {
  .image-status {
    position: absolute;
    top: 11px;
    left: 4px;
  }

  .content_danger {
    position: relative;
    top: -11px;
    left: 12px;
    display: flex;
  }
  .students-table .table__col:nth-child(7) {
    line-break: anywhere;
    left: 30px;
  }
  .students-table .table__col:nth-child(6) {
    line-break: anywhere;
    left: 72px;
  }
}
</style>
